import React, { useEffect, useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Hidden from "@material-ui/core/Hidden";
// @material-ui/icons
import Menu from "@material-ui/icons/Menu";
// core components
import AdminNavbarLinks from "./AdminNavbarLinks.js";
import RTLNavbarLinks from "./RTLNavbarLinks.js";
import { NavLink } from "react-router-dom";
import constants from "../../constants/navbarOptions";
import { useUser } from "../../context/userContext";
//hooks
import { useRouteName } from "hooks";
import styles from "assets/jss/material-dashboard-react/components/headerStyle.js";
import stylesBtn from "assets/jss/material-dashboard-react/components/buttonStyle";
import { Button } from "@material-ui/core";
import ButtonSystemControl from "components/CustomButtons/ButtonSystemControl.jsx";
import AutomatoSelector from "../AutomatoSelector/AutomatoSelector.js";
import { useDot } from "../../context/automatonContext.jsx";

const useStyles = makeStyles(styles);
const useStylesBtn = makeStyles(stylesBtn);

export default function Header(props) {
  const routeName = useRouteName();
  const [isDisabledBtn, setDisableBtn] = useState(false);
  const { language, isAdmin, setIsAdmin, isAuth } = useUser();
  const { automatonType } = useDot();
  const [automatonTypeName, setAutomatonTypeName] = useState(
    constants.automatonSelector.placeholder[language]
  );

  const machineNames = {
    AF: constants.automatonSelector.machineTypes.AF[language],
    AP: constants.automatonSelector.machineTypes.AP[language],
    ALL: constants.automatonSelector.machineTypes.ALL[language],
    MT: constants.automatonSelector.machineTypes.MT[language],
  };

  useEffect(() => {
    if (routeName === "Draw" || routeName === "Response automaton") {
      setDisableBtn(false);
    } else {
      setDisableBtn(true);
    }
  }, [routeName]);

  useEffect(() => {
    setIsAdmin(isAdmin);
  }, [isAdmin]);

  useEffect(() => {
    const newName =
      machineNames[automatonType] ||
      constants.automatonSelector.placeholder[language];
    setAutomatonTypeName(newName);
  }, [automatonType, language]);

  const classes = useStyles();
  const classesBtn = useStylesBtn();

  const { color } = props;
  const appBarClasses = classNames({
    [" " + classes[color]]: color,
  });

  const returnBackgroundColorByRoute = (button) => {
    if (button === "draw") {
      if (routeName === "Draw") {
        return "blue";
      } else {
        return "";
      }
    } else if (button === "response") {
      if (routeName === "Response automaton") {
        return "blue";
      } else {
        return "";
      }
    }
  };

  const shouldShowNavButtons =
    routeName === "Draw" || routeName === "Response automaton";
  const shouldShowAutomatonSelector = routeName === "Draw";

  return (
    <AppBar className={classes.appBar + appBarClasses}>
      <Toolbar
        className={classes.container}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* Grupo Esquerdo: Botões de Resposta e Desenho, nome da máquina e Seletor de Autômato */}
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {isAuth && shouldShowNavButtons && (
            <>
              <Button
                disabled={isDisabledBtn}
                className={classesBtn.button}
                style={{
                  backgroundColor: returnBackgroundColorByRoute("draw"),
                }}
              >
                <NavLink to="/user/automaton" key={0} className={classes.link}>
                  {constants.buttons.optionsDraw.draw[language]}
                </NavLink>
              </Button>
              <Button
                disabled={isDisabledBtn}
                className={classesBtn.button}
                style={{
                  backgroundColor: returnBackgroundColorByRoute("response"),
                }}
              >
                <NavLink
                  to="/user/responseAutomaton"
                  key={1}
                  className={classes.link}
                >
                  {constants.buttons.optionsDraw.response[language]}
                </NavLink>
              </Button>
            </>
          )}
          {isAuth && shouldShowAutomatonSelector && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "25px",
              }}
            >
              {/* Nome do Automato */}
              <span
                style={{
                  minWidth: "280px",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                }}
              >
                {automatonTypeName}
              </span>

              <AutomatoSelector />
            </div>
          )}
        </div>

        {/* GRUPO CENTRAL: switch  */}
        <div
          style={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 20px",
          }}
        >
          {isAuth && shouldShowAutomatonSelector && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "15px",
              }}
            >
              {isAdmin && <ButtonSystemControl />}
            </div>
          )}
        </div>

        {/* Grupo Direito: Apenas Links de Admin/Bandeiras/Menu */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            flexShrink: 0,
          }}
        >
          {isAuth && !shouldShowAutomatonSelector && isAdmin && (
            <ButtonSystemControl />
          )}

          <Hidden smDown implementation="css">
            {props.rtlActive ? (
              <RTLNavbarLinks />
            ) : (
              <AdminNavbarLinks
                router={routeName}
                rtlActive={props.rtlActive}
              />
            )}
          </Hidden>
          <Hidden mdUp implementation="css">
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={props.handleDrawerToggle}
            >
              <Menu />
            </IconButton>
          </Hidden>
        </div>
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  routes: PropTypes.arrayOf(PropTypes.object),
};
